export class KafkaSecurityConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "securityProtocol",
            "baseName": "securityProtocol",
            "type": "KafkaSecurityProtocol",
            "format": ""
        },
        {
            "name": "saslMechanism",
            "baseName": "saslMechanism",
            "type": "KafkaSaslMechanism",
            "format": ""
        },
        {
            "name": "credentialsSecret",
            "baseName": "credentialsSecret",
            "type": "KafkaSecurityConfigInputCredentialsSecret",
            "format": ""
        },
        {
            "name": "tlsSecret",
            "baseName": "tlsSecret",
            "type": "KafkaSecurityConfigInputTlsSecret",
            "format": ""
        },
        {
            "name": "skipTlsVerification",
            "baseName": "skipTlsVerification",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSecurityConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
